module.exports = __webpack_public_path__ + "img/entities.354f61a2.svg";